import * as yup from "yup";

const RequiredMessage = name => `${name} ضروری است`;
const SignUpValidSchema = yup.object().shape({
  name: yup
    .string()
    .required("نام ضروری است")
    .matches(/^[\u0600-\u06FF\s]+$/, "نام شما باید فارسی باشد"),
  family: yup
    .string()
    .required("نام خانوادگی ضروری است")
    .matches(/^[\u0600-\u06FF\s]+$/, "نام خانوادگی شما باید فارسی باشد"),
  nationalcode: yup
    .number()
    .required("کدملی ضروری است")
    .test(
      "valid Code length",
      "کد ملی باید 10 رقم باشد",
      (val = "") => String(val).length === 10
    ),
  reagentid: yup.number(),
  password: yup
    .string()
    .required("پسورد ضروری است")
    .min(4, "حداقل طول رمز عبور باید 4 حرف باشد")
    .max(16, "حداکثر طول رمز عبور باید 16 حرف باشد"),
  ConfirmPassword: yup
    .string()
    .required("تایید پسورد را وارد کنید")
    .oneOf([yup.ref("password"), null], "پسورد ها یکسان نیستند")
});
const LoginValidSchema = yup.object().shape({
  mobilenumber: yup.number().required(),
  password: yup.string().required()
});

const AddCustomerInformationValidationSchema = yup.object().shape({
  customername: yup.string().required(RequiredMessage("نام")),
  customerjob: yup.string().required(RequiredMessage("شغل")),
  city: yup.string().required(RequiredMessage("شهر")),
  secondPhoneNumber: yup.number().required(RequiredMessage("شماره تماس دوم")),
  customeraddres: yup.string().required(RequiredMessage("آدرس")),
  description: yup.string().required(RequiredMessage("توضیحات"))
});
export {
  SignUpValidSchema,
  LoginValidSchema,
  AddCustomerInformationValidationSchema
};
